// search-store.ts
import { createStore } from "zustand/vanilla";

export type SearchState = {
  query: string;
};

export type SearchActions = {
  setQuery: (newQuery: string) => void;
  clearQuery: () => void;
};

export type SearchStore = SearchState & SearchActions;

export const initSearchStore = (): SearchState => ({
  query: "",
});

export const createSearchStore = (
  initState: SearchState = initSearchStore(),
) => {
  return createStore<SearchStore>()((set) => ({
    ...initState,
    setQuery: (newQuery) => {
      set({ query: newQuery });
    },
    clearQuery: () => {
      set({ query: "" });
    },
  }));
};
